import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { selectCurrentPartner, setSelectedPartner } from "../../model"
import { SelectPartner } from "@/features/partner"

export const MapFilters = () => {
    const dispatch = useAppDispatch()
    const partnerId = useAppSelector(selectCurrentPartner)

    const handleSelectPartner = (value: string | null) => {
        dispatch(setSelectedPartner(value))
    }

    return (
        <div className="w-full max-w-md">
            <SelectPartner value={partnerId} onChange={handleSelectPartner} />
        </div>
    )
}